// @flow
export const filterId: 'date' = 'date';
